import { render, staticRenderFns } from "./ClassroomsView.vue?vue&type=template&id=88921aea"
import script from "./ClassroomsView.vue?vue&type=script&lang=js"
export * from "./ClassroomsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports